import React from "react";
import PageLayout from "../../PageLayout";
import SecondPage from "./SecondPage";
import FourthPage from "./FourthPage";
import VideoCareer from "./VideoCareer";

const videos = [
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/EUQ2H3X7lfM?si=S_yMOX4AVMYcKibl"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/QzYKO6x-cjU?si=eWl3Vg_t_IR3gGKf"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/pRoonyg7zMw?si=2m-AOrWCi4xRKgFU"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/OzJS3OqkoBY?si=X3uqwZezOoTDgQB3"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/Fni9TdzNF1A?si=-0-_wqd046F0B2dD"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>
];

function RealState() {
  return (
    <div>
      <PageLayout
        title="Let us give wings to your stories"
        description="We at IBEX FILMZ understand the evolving landscape of digital media and its impact on audiences worldwide. Leveraging cutting-edge technology and creative storytelling, we ensure that each video or film we produce not only meets but exceeds the expectations of our clients. Our team of experts specializes in bringing ideas to life, transforming visions into cinematic experiences that resonate with viewers, leaving a lasting impression. "
        videosrc="./video.mp4"
      />
      <SecondPage
        title="Real Estate Video Productions"
        para="Explore the world of luxury living and architectural elegance with our real estate video production playlist! 
Join us as we showcase stunning properties, exquisite interiors, and breathtaking landscapes captured by our skilled team at IBEX FILMZ. From lavish penthouses to tranquil retreats, our videos offer a glimpse into the finest properties on the market. Whether you're a homebuyer, investor, or simply an admirer of fine craftsmanship, our videos will inspire and captivate you.
"
      />
      <VideoCareer videos={videos} />

      {/* <FourthPage /> */}
    </div>
  );
}

export default RealState;
